import { AxiosResponse } from 'axios';
import { bunja } from 'bunja';
import { atom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';

import { getTradingCompetitionApi, getTradingCompetitionRankingsApi } from '@flipster/apis/v2/trading-competition';
import {
  RankingType,
  TradingCompetition,
  TradingCompetitionRankings,
  isRankingType,
} from '@flipster/apis/v2/trading-competition/types';

import { competitionBunja, competitionTabsBunja } from '../../state';

export const lastChampionsBunja = bunja(() => {
  const { competitionAtom } = bunja.use(competitionBunja);
  const { selectedEventTabValueAtom } = bunja.use(competitionTabsBunja);

  const lastCompetitionAtom = atomWithQuery((get) => {
    const lastCompetitionId = get(competitionAtom)?.previousCompetitionUrl;
    return {
      queryKey: ['getTradingCompetition', lastCompetitionId],
      queryFn: () => getTradingCompetitionApi(lastCompetitionId ?? ''),
      select: (res: AxiosResponse<TradingCompetition>) => res.data,
      enabled: Boolean(lastCompetitionId),
    };
  });

  const lastCompetitionPeriodAtom = atom((get) => {
    const { data: lastCompetition } = get(lastCompetitionAtom);
    return {
      start: lastCompetition?.competitionStartTime,
      end: lastCompetition?.competitionEndTime,
    };
  });

  const lastCompetitionRankingsAtoms = atomWithQuery((get) => {
    const lastCompetitionId = get(competitionAtom)?.previousCompetitionUrl;
    const rankingMethod = get(selectedEventTabValueAtom) as RankingType;

    return {
      queryKey: ['getTradingCompetitionRankings', lastCompetitionId, rankingMethod],
      queryFn: () =>
        getTradingCompetitionRankingsApi({
          competitionUrl: lastCompetitionId ?? '',
          rankingMethod,
          myRanking: false,
        }),
      select: (res: AxiosResponse<TradingCompetitionRankings>) => res.data.data,
      enabled: Boolean(lastCompetitionId) && isRankingType(rankingMethod),
    };
  });

  const hasLastCompetitionAtom = atom((get) => Boolean(get(competitionAtom)?.previousCompetitionUrl));

  const lastCompetitionChampionsAtom = atom((get) => get(lastCompetitionRankingsAtoms)?.data?.slice(0, 3));

  return {
    lastCompetitionRankingsAtoms,
    hasLastCompetitionAtom,
    lastCompetitionChampionsAtom,
    lastCompetitionPeriodAtom,
  };
});
lastChampionsBunja.debugLabel = 'lastChampionsBunja';
